var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 445.735,
    height: 190.588,
    viewBox: "0 0 445.735 190.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_page_not_found_su7k",
    transform: "translate(-54.804 -155.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4756",
    "data-name": "Path 4756",
    d: "M504,324.894c-39.681,0-68.171,25.458-68.171,84.861,0,67.323,28.49,85.143,68.171,85.143s69.869-19.518,69.869-85.143C573.869,339.6,543.681,324.894,504,324.894Zm.261,147.657c-27.484,0-41.842-16.124-41.842-62.753,0-41.143,14.946-62.84,42.43-62.84s42.43,14.252,42.43,62.84C547.279,455.252,531.745,472.552,504.261,472.552Z",
    transform: "translate(-234.216 -163.821)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4757",
    "data-name": "Path 4757",
    d: "M240.906,455.73H224.5V407.418a9.675,9.675,0,0,0-9.675-9.675H210.98a9.675,9.675,0,0,0-9.675,9.675V455.73H155.028a5.523,5.523,0,0,1-4.884-8.1l48.979-92.7a9.675,9.675,0,0,0-4.423-13.269l-2.891-1.365a9.675,9.675,0,0,0-12.664,4.188L119.408,456.226a13.12,13.12,0,0,0-1.549,6.185h0a13.12,13.12,0,0,0,13.12,13.12H201.3v30.55a11.6,11.6,0,0,0,11.6,11.6h0a11.6,11.6,0,0,0,11.6-11.6v-30.55h16.406a9.9,9.9,0,0,0,9.9-9.9h0a9.9,9.9,0,0,0-9.9-9.9Z",
    transform: "translate(-63.054 -171.609)",
    fill: "#925b35",
    opacity: 0.718
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4758",
    "data-name": "Path 4758",
    d: "M898.9,455.73H882.5V407.418a9.675,9.675,0,0,0-9.675-9.675h-3.844a9.675,9.675,0,0,0-9.675,9.675V455.73H813.024a5.523,5.523,0,0,1-4.884-8.1l48.979-92.7a9.676,9.676,0,0,0-4.423-13.269l-2.891-1.365a9.676,9.676,0,0,0-12.664,4.188L777.4,456.226a13.12,13.12,0,0,0-1.549,6.185h0a13.12,13.12,0,0,0,13.12,13.12H859.3v30.55a11.6,11.6,0,0,0,11.6,11.6h0a11.6,11.6,0,0,0,11.6-11.6v-30.55H898.9a9.9,9.9,0,0,0,9.9-9.9h0a9.9,9.9,0,0,0-9.9-9.9Z",
    transform: "translate(-417.25 -171.609)",
    fill: "#925b35",
    opacity: 0.718
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4759",
    "data-name": "Path 4759",
    d: "M250.709,443.477H234.3V395.164a9.675,9.675,0,0,0-9.675-9.675h-3.844a9.675,9.675,0,0,0-9.675,9.675v48.313H164.83a5.524,5.524,0,0,1-4.884-8.1l48.979-92.7A9.675,9.675,0,0,0,204.5,329.4l-2.891-1.365a9.675,9.675,0,0,0-12.664,4.188L129.21,443.973a13.12,13.12,0,0,0-1.549,6.185h0a13.12,13.12,0,0,0,13.12,13.12h70.326v30.55a11.6,11.6,0,0,0,11.6,11.6h0a11.6,11.6,0,0,0,11.6-11.6v-30.55h16.406a9.9,9.9,0,0,0,9.9-9.9h0a9.9,9.9,0,0,0-9.9-9.9Z",
    transform: "translate(-68.331 -165.013)",
    fill: "none",
    stroke: "#3f3d56",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4760",
    "data-name": "Path 4760",
    d: "M917.282,443.477H900.876V395.164a9.676,9.676,0,0,0-9.675-9.675h-3.844a9.675,9.675,0,0,0-9.675,9.676v48.313H831.4a5.524,5.524,0,0,1-4.884-8.1l48.979-92.7a9.675,9.675,0,0,0-4.423-13.269l-2.891-1.365a9.675,9.675,0,0,0-12.664,4.188L795.784,443.973a13.119,13.119,0,0,0-1.549,6.185h0a13.12,13.12,0,0,0,13.12,13.12h70.326v30.55a11.6,11.6,0,0,0,11.6,11.6h0a11.6,11.6,0,0,0,11.6-11.6v-30.55h16.406a9.9,9.9,0,0,0,9.9-9.9h0A9.9,9.9,0,0,0,917.282,443.477Z",
    transform: "translate(-427.143 -165.013)",
    fill: "none",
    stroke: "#3f3d56",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4761",
    "data-name": "Path 4761",
    d: "M523.605,313.866c-39.681,0-68.171,25.458-68.171,84.861,0,67.323,28.49,85.143,68.171,85.143s69.869-19.518,69.869-85.143C593.474,328.576,563.286,313.866,523.605,313.866Zm.261,147.657c-27.484,0-41.843-16.124-41.843-62.753,0-41.143,14.946-62.84,42.43-62.84s42.43,14.252,42.43,62.84c0,45.454-15.534,62.753-43.018,62.753Z",
    transform: "translate(-244.769 -157.885)",
    fill: "none",
    stroke: "#3f3d56",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4763",
    "data-name": "Path 4763",
    d: "M609.821,335.069c-.359,1.474-1.906,2.655-3.619,3.48-3.6,1.735-8.045,2.252-12.355,2.426a20.854,20.854,0,0,1-3.3-.061,9.482,9.482,0,0,1-5.656-2.6.776.776,0,0,1,.02-1.313c2.294-2.52,6.123-4.066,9.98-5.179,2.925-.844,8.025-3.029,11.215-2.734C609.2,329.374,610.274,333.207,609.821,335.069Z",
    transform: "translate(-314.266 -166.064)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4764",
    "data-name": "Path 4764",
    d: "M609.821,335.069c-.359,1.474-1.906,2.655-3.619,3.48-3.6,1.735-8.045,2.252-12.355,2.426a20.854,20.854,0,0,1-3.3-.061,9.482,9.482,0,0,1-5.656-2.6.776.776,0,0,1,.02-1.313c2.294-2.52,6.123-4.066,9.98-5.179,2.925-.844,8.025-3.029,11.215-2.734C609.2,329.374,610.274,333.207,609.821,335.069Z",
    transform: "translate(-314.266 -166.064)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 7.849,
    cy: 10.158,
    rx: 7.849,
    ry: 10.158,
    transform: "translate(243.707 221.144)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 7.849,
    cy: 10.158,
    rx: 7.849,
    ry: 10.158,
    transform: "translate(286.415 221.375)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4795",
    "data-name": "Path 4795",
    d: "M590.126,532.811c0,4.589-6.408,8.311-14.313,8.311S561.5,537.4,561.5,532.811c0-3.975,4.806-7.3,11.229-8.112a23.121,23.121,0,0,1,3.084-.2,23.4,23.4,0,0,1,5.139.554C586.317,526.25,590.126,529.274,590.126,532.811Z",
    transform: "translate(-301.864 -271.267)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 7.849,
    cy: 10.158,
    rx: 7.849,
    ry: 10.158,
    transform: "translate(245.554 218.836)",
    fill: "none",
    stroke: "#3f3d56",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 7.849,
    cy: 10.158,
    rx: 7.849,
    ry: 10.158,
    transform: "translate(288.262 219.066)",
    fill: "none",
    stroke: "#3f3d56",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 14.313,
    cy: 8.311,
    rx: 14.313,
    ry: 8.311,
    transform: "translate(261.483 250.924)",
    fill: "none",
    stroke: "#3f3d56",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4796",
    "data-name": "Path 4796",
    d: "M593.771,525.477a2.279,2.279,0,0,1-.609,1.566,2,2,0,0,1-1.468.65h-4.617A2.153,2.153,0,0,1,585,525.477a2.265,2.265,0,0,1,.379-1.266,21.715,21.715,0,0,1,3.084-.212,22,22,0,0,1,5.139.591,2.338,2.338,0,0,1,.171.887Z",
    transform: "translate(-314.513 -270.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 2.309,
    cy: 2.309,
    r: 2.309,
    transform: "translate(251.095 223.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 2.309,
    cy: 2.309,
    r: 2.309,
    transform: "translate(294.033 223.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 2.309,
    cy: 2.309,
    r: 2.309,
    transform: "translate(296.342 245.614)",
    fill: "#12819c",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 2.309,
    cy: 2.309,
    r: 2.309,
    transform: "translate(240.014 245.614)",
    fill: "#12819c",
    opacity: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/page_not_found.5834b575f914fcd1b10aab5ff1c81986.svg";
export { ForwardRef as ReactComponent };